import * as THREE from 'three'

export type CameraMode = 'attract' | 'follow'

/** Isometric-style follow camera with a cinematic attract orbit for menus. */
export class CameraRig {
  readonly cam: THREE.PerspectiveCamera
  mode: CameraMode = 'attract'

  private target = new THREE.Vector3(0, 0, 0)
  private desired = new THREE.Vector3()
  private lookDesired = new THREE.Vector3()
  private lookCurrent = new THREE.Vector3()
  private followOffset = new THREE.Vector3(0, 18, 12)
  private t = 0

  constructor(aspect: number) {
    this.cam = new THREE.PerspectiveCamera(48, aspect, 0.1, 400)
    this.cam.position.set(34, 26, 0)
    this.cam.lookAt(0, 0, 0)
  }

  setAspect(a: number): void {
    this.cam.aspect = a
    this.cam.updateProjectionMatrix()
  }

  setFollowTarget(x: number, z: number): void {
    this.target.set(x, 0, z)
  }

  /** Snap instantly (used when entering follow mode at match start). */
  snapToFollow(): void {
    this.mode = 'follow'
    this.desired.copy(this.target).add(this.followOffset)
    this.cam.position.copy(this.desired)
    this.lookCurrent.copy(this.target)
    this.cam.lookAt(this.lookCurrent)
  }

  update(dt: number): void {
    this.t += dt
    if (this.mode === 'attract') {
      const r = 36
      const a = this.t * 0.075
      this.desired.set(Math.cos(a) * r, 27 + Math.sin(this.t * 0.25) * 2.5, Math.sin(a) * r)
      this.lookDesired.set(0, 1.5, 0)
    } else {
      this.desired.copy(this.target).add(this.followOffset)
      this.lookDesired.copy(this.target)
    }
    const posL = this.mode === 'attract' ? 1.4 : 7.5
    const lookL = this.mode === 'attract' ? 1.4 : 9
    this.cam.position.lerp(this.desired, 1 - Math.exp(-posL * dt))
    this.lookCurrent.lerp(this.lookDesired, 1 - Math.exp(-lookL * dt))
    this.cam.lookAt(this.lookCurrent)
  }
}
